import AxiosConfig from '@/config/axios-config'

export const SistemaAPI = {

  listarHome () {
    return AxiosConfig.secureJalekoAPI().get('/sistemas').then(response => response.data)
  },

  obterPorReferencia (referencia) {
    return AxiosConfig.secureJalekoAPI().get(`/sistemas/${referencia}`).then(response => response.data)
  },

  obterEstatisticas (referencia) {
    return AxiosConfig.secureJalekoAPI().get(`/resumosistema/${referencia}`).then(response => response.data)
  }

}

export default SistemaAPI
